import React from "react";

export default function TablesFactures({
  infoDataTableBody,
  infoDataTableHead,
}) {
  return (
    <table style={{ border: "1px solid black", width: "100%" }}>
      <TheadBodyTable infoDataTableHead={infoDataTableHead} />
      <BodyOfTable infoDataTableBody={infoDataTableBody} />
      {/* <tbody>
              <tr className="border-top  border-dark">
                <td className="p-2 text-start" >
                  LOYER : (MONTANT DU LOYER CAUTION DE {nombre_mois_caution}{" "}
                  MOIS :)
                </td>
                <td className="p-2">
                  {Help.convertInMoney(Number(cost))}
                </td>
                <td className="p-2">
                  {nombre_mois_caution}
                </td>
                <td className="p-2">
                  {Help.convertInMoney(
                    Number(cost) * Number(nombre_mois_caution)
                  )}
                </td>
              </tr>
              <tr>
                <td className="p-2 text-start">
                  AVANCE DU LOYER {nombre_mois_avance ? nombre_mois_avance : 0}{" "}
                  MOIS
                </td>
                <td className="p-2">
                  {Help.convertInMoney(Number(cost))}
                </td>
                <td className="p-2">
                  {nombre_mois_avance ? nombre_mois_avance : 0}
                </td>
                <td className="p-2">
                  {nombre_mois_avance
                    ? Help.convertInMoney(
                        Number(cost) * Number(nombre_mois_avance)
                      )
                    : 0}
                </td>
              </tr>
              <tr>
                <td className="p-2 text-start">
                  FRAIS D’AGENCE
                </td>
                <td className="p-2">
                  {Help.convertInMoney(Number(cost))}
                </td>
                <td className="p-2">
                  1
                </td>
                <td className="p-2">
                  {Help.convertInMoney(Number(cost))}
                </td>
              </tr>
              <tr className="border-bottom border-dark">
                <td
                  colSpan="3"
                  className="p-2 text-start"
                  style={{ textAlign: "text-left" }}
                >
                  FRAIS DE DOSSIER (10% DU LOYER)
                </td>

                <td>{Help.convertInMoney((Number(cost) * 10) / 100)}</td>
              </tr>
              <tr className="border-bottom border-dark">
                <td
                  colSpan="3"
                  className="p-2 text-start"
                  style={{ textAlign: "text-left" }}
                >
                  TOTAL A PAYER
                </td>
                <td>
                  {Help.convertInMoney(
                    calculeTotal(nombre_mois_avance, cost, nombre_mois_caution)
                  )}
                </td>
              </tr>
            </tbody> */}
    </table>
  );
}

const TheadBodyTable = ({ infoDataTableHead }) => {
  return (
    <thead>
      <RangeTR>
        {infoDataTableHead.map((item, index) => (
          <ColonneTh key={index} libelle={item.libelle} />
        ))}
      </RangeTR>
    </thead>
  );
};

const BodyOfTable = ({ infoDataTableBody }) => {
  return (
    <tbody>
      {infoDataTableBody.map((item, index) => (
        <RangeTR key={index} className={item.className}>
          {item?.coloneTd.map((colTd, index) => (
            <ColonneTd
              key={index}
              style={colTd.style}
              colSpan={colTd.colSpan}
              tdlibelle={colTd.libelle}
            />
          ))}
        </RangeTR>
      ))}
    </tbody>
  );
};

const ColonneTh = ({ libelle }) => {
  return <th className="p-2">{libelle}</th>;
};

const ColonneTd = ({ tdlibelle, colSpan }) => {
  return (
    <td className="p-2 text-start" colSpan={colSpan}>
      {tdlibelle}
    </td>
  );
};
const RangeTR = ({ children }) => {
  return <tr className="text-start">{children}</tr>;
};
